module.exports = __webpack_public_path__ + "static/media/decoline.bd7e6cd9.svg";